<template>
  <div id="Index">
    <input type="file" ref="import" @change="importInputChange" v-show="false">
    <jw-frame>
      <template slot="extra">
        <i-button type="primary" @click="$refs['dans'].editDanInfo('create',{})">添加段位证书</i-button>
        <Dropdown style="margin-left: 5px;">
          <Button type="text" size="small">
            证书导入
            <Icon type="md-arrow-dropdown" />
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem style="text-align: center;">
              <a href="http://www.sjgzg.com/api/download/%E4%B8%AD%E5%9B%BD%E5%8F%8C%E8%8A%82%E6%A3%8D%E5%8D%8F%E4%BC%9A%E6%AE%B5%E4%BD%8D%E8%AF%81%E4%B9%A6%E5%AF%BC%E5%85%A5%E8%A1%A8.xlsx" style="color: #515a6e;">
                下载导入模板
              </a>
            </DropdownItem>
            <DropdownItem style="text-align: center;">
              <a href="javascript:;" @click="handleImportAction" style="color: #515a6e;">导入段位证书</a>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </template>

      <Form
          ref           ="formValidate"
          :label-colon  ="true"
          :model        ="filter"
          style="margin-top: 15px;"
      >
        <Row :gutter="12">
          <Col span="6">
            <FormItem prop="cert_no">
              <Input v-model="filter.cer_no" placeholder="证书编号"
                     @on-enter="handleGetGrades"
                     maxlength="25" :show-word-limit="true"
              ></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem prop="stu_name">
              <Input v-model="filter.m_name" placeholder="会员姓名"
                     @on-enter="handleGetGrades"
                     maxlength="15" :show-word-limit="true"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <table width="100%;">
        <thead>
        <tr>
          <th style="width: 120px;">证书编号</th>
          <th style="width: 120px;text-align: center;">会员姓名</th>
          <th style="width: 120px;text-align: center;">性 别</th>
          <th style="width: 120px;text-align: center;">段位等级</th>
          <th style="width: 120px;text-align: center;">考试时间</th>
          <!--          <th style="width: 120px;text-align: center;">所属分盟</th>-->
          <th style="width: 120px;text-align: center;">考官编号</th>
          <th style="width: 120px;text-align: center;">编辑</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(grade, index) in grades" :class="[index%2 === 0 ? 'noHover' : 'hover']">
          <td style="width: 120px;text-align: left;">
            {{grade['cer_no']}}
          </td>
          <td style="width: 120px;text-align: center;">
            {{grade['m_name']}}
          </td>
          <td style="width: 120px;text-align: center;">
            {{grade['m_sex'] === '1' ? '男' : '女'}}
          </td>
          <td style="width: 120px;text-align: center;">
            {{grade['level_name']}}
          </td>
          <td style="width: 120px;text-align: center;">
            {{grade['time']}}
          </td>
          <!--          <td style="width: 120px;text-align: center;">-->
          <!--            {{grade['lea_name']}}-->
          <!--          </td>-->
          <td style="width: 120px;text-align: center;">
            {{grade['lea_leader']}}
          </td>
          <td style="width: 120px;text-align: center;">
            <i-button type="text" @click="$refs['dans'].editDanInfo('update', grade)">修改</i-button>
          </td>
        </tr>
        <tr v-if="grades.length === 0">
          <td colspan="10" style="text-align: center;padding: 10px 0;">
            暂未查询到证书记录
          </td>
        </tr>
        </tbody>
      </table>
      <div style="text-align: center;margin-top: 10px;">
        <Page
            @on-change="handlePageChangeAction"
            @on-page-size-change="handlePageSizeChangeAction"
            :total="totalCount"
            :page-size="pageSize"
            show-sizer
        />
      </div>
    </jw-frame>
    <detail ref="dans" @refresh="handleGetGrades"></detail>

    <!-- 显示导入错误信息-->
    <Modal
        v-model="showErrMsgModel"
        :closable="false"
        width="60%"
        okText="确 定"
        cancelText=''
        :title="errorTitle">
      <table width="100%;">
        <thead>
        <tr>
          <th style="width: 50px;">行</th>
          <th style="width: 100px;">证书编号</th>
          <th style="width: 120px;">学员姓名</th>
          <th style="width: 500px;">错误原因</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(error, index) in errorList" :class="[index%2 === 0 ? 'noHover' : 'hover']">
          <td style="width: 50px;">
            {{error['index']}}
          </td>
          <td style="width: 100px;">
            {{error['cer_no']}}
          </td>
          <td style="width: 100px;">
            {{error['m_name']}}
          </td>
          <td style="width: 500px;">
            {{error['err_msg']}}
          </td>
        </tr>
        <tr v-if="errorList.length === 0">
          <td colspan="9" style="text-align: center;padding: 10px 0;">
            暂无错误
          </td>
        </tr>
        </tbody>
      </table>
    </Modal>
  </div>
</template>

<script>
import { importCertificateList } from "@/request/ranks";
import { getGrades } from "@/request/dans";
import Detail from "@/views/admin/dans/Detail";
import Excel from "@/utils/excel";

export default {
  name: "Index",
  // 注册组件
  components: {
    Detail
  },
  props: {},
  // 计算属性，用来监控自己定义的变量，该变量不在data里面声明，直接在computed里面定义，然后就可以在页面上进行双向数据绑定展示出结果或者用作其他处理
  computed: {},
  data () {
    return {
      errorList: [],
      errorTitle: '',
      showErrMsgModel: false,
      grades: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      filter: {
        cer_no: '',
        m_name: ''
      }
    }
  },
  methods: {
    importInputChange() {
      const excel = new Excel(this, event, (titleArray,excelData)=> {
        let titles = ["*证书编号", "*会员姓名", "*会员性别", "身份证号", "*出生日期", "*段位等级", "*升段日期", "*考官编号"];
        // 转化数组
        let CN2EngKeys = {
          '*证书编号' : 'cer_no',
          '*会员姓名' : 'm_name',
          '*会员性别' : 'm_sex',
          '身份证号'  : 'm_id',
          '*出生日期' : 'birth',
          '*段位等级' : 'level_name',
          '*升段日期' : 'time',
          '*考官编号' : 'lea_leader'
        };
        // 校验表头数据

        let isEqualWith = require('lodash.isequalwith');
        if (!isEqualWith(titleArray, titles)) {
          this.$Notice.error({
            title: '错误提示',
            desc: '非级段位证书导入表，禁止导入'
          });
          return;
        }
        // 将对象中的中文key转化为英文key
        let result = excel.dateTransition(excelData, CN2EngKeys);
        importCertificateList({ list: result, type: 'dan' }).then(res=> {
          let { error, message, data } = res.data;
          if (error === 200) {
            // this.errorMsgModel= true
            this.$Notice.success({
              title: '成功提示！',
              desc: message
            });
            this.handleGetGrades();
          } else {
            this.errorList = data;
            this.errorTitle = '段位证书导入失败';
            this.showErrMsgModel = true;
          }
        })
      })
      this.$refs.import.value = ''
    },
    handleImportAction() {
      this.$refs.import.click();
    },
    handleGetGrades() {
      getGrades({ pageIndex: this.pageIndex, pageSize: this.pageSize, filter: this.filter }).then(res=> {
        let { list, total_count } = res.data.data;
        this.totalCount = total_count;
        this.grades = list
      })
    },
    handlePageChangeAction(pageIndex) {
      this.pageIndex = pageIndex;
      this.handleGetGrades()
    },
    handlePageSizeChangeAction(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.handleGetGrades()
    }
  },
  created () {
    this.handleGetGrades();
  }
}
</script>

<style scoped>
table {
  text-align: left;
  width: 100%;
  color: #1fbba6;
  font-weight: bold;
  border-collapse:collapse;
}

table thead {
  color: #fff;
  background-color: #1fbba6
}

table thead tr {
  color: #fff;
}

table thead tr th {
  padding: 10px 5px;
  height: 44px;
}

table tbody tr:hover {
  cursor:default;
  background-color: rgba(104, 216, 254, 0.4);
}

table tbody tr td{
  padding: 8px 5px;
}

table body tr td p{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

table tbody .hover {
  background-color: rgba(255, 255, 255, 0.5)
}

table tbody .noHover {
  background-color: rgba(128, 134, 149, 0.15)
}
</style>
